import DelayIcon from "../icons/delay_icon"
import FilterIcon from "../icons/filter_icon"

interface Props {
  brandColor: string
  image?: string
  name: string
  serviceName: string
  serviceModuleName?: string
  stepUrl?: string
  label: string
  finalStep?: boolean
  description?: string
}

const StepDetails = ({ brandColor, image, name, serviceName, serviceModuleName, stepUrl, label, finalStep, description }: Props) => {
  const isFilter = label === "When"
  const isDelay = label === "Wait"
  const largeImage = label === "If" || label === "Then"

  const serviceImage = () => {
    if (isFilter) {
      return <FilterIcon title={serviceName} />
    } else if (isDelay) {
      return <DelayIcon title={serviceName} />
    } else {
      if (serviceModuleName) {
        return <a href={`/${serviceModuleName}`} title={serviceName}><img src={image} alt={`${serviceName} icon`} loading="lazy" /></a>
      } else {
        return <img src={image} alt={`${serviceName} icon`} loading="lazy" />
      }
    }
  }

  return (
    <>
      <div className={finalStep ? "step final" : "step"}>
        <div className="details-row">
          <h3 className="label">{label}</h3>
          <div className="icon">
            <div className={largeImage ? "large" : "small"} style={{ backgroundColor: brandColor }}>
              {serviceImage()}
            </div>
          </div>
          <div className="details">
            <h5 className="service-name">
              {stepUrl ? (
                <a href={stepUrl} title={name}>
                  {name}
                </a>
                ) : name
              }
            </h5>
            {isFilter || isDelay ? <></> : <p className="txt-caption">
              {description ? description : name} {!stepUrl ? (
                <a href={stepUrl} class="link-inline" title="Learn more">
                  Learn more
                </a>
                ) : null
              }</p>}
          </div>
        </div>
      </div>
      {finalStep ? null : (
        <div className="guideline-container">
          <div className="label" />
          <div className="guideline" />
        </div>
      )}
    </>
  )
}

export default StepDetails
